import React from "react";
import { Box, Typography } from "@mui/material";
import "../Receipt.css";

const GrandTotalBox = ({ grandTotal }) => (
  <Box className="grand-total-box-receipt">
    <Typography className="grand-total-text">Grand Total</Typography>
    <Typography className="grand-total-text">{grandTotal}</Typography>
  </Box>
);

export default GrandTotalBox;
